import { AppRouter } from './router/AppRouter';

export const WebXMex = () => {
  return <AppRouter />;
};
